@if (deviceService.$isMobile() && visible()) {
<lib-bottom-sheet
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  size="full"
  [draggable]="true"
  [closeOnBackdrop]="!saving()"
  [closeOnEscape]="!saving()"
  [preventClose]="saving()"
  [headerTemplate]="headerTemplateView"
  [footerTemplate]="footerTemplate"
>
  <ng-container *ngTemplateOutlet="conteudoTemplate"></ng-container>
</lib-bottom-sheet>
} @else {
<p-dialog
  [visible]="visible()"
  (visibleChange)="onVisibleChange($event)"
  [modal]="true"
  [closable]="false"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="!saving()"
  [showHeader]="true"
  styleClass="dialog-mobile-scroll rounded-3xl shadow-4"
  [style]="{ height: '660px', width: '700px' }"
  [contentStyle]="{ overflow: 'auto', height: '100%' }"
>
  <ng-template pTemplate="header">
    <ng-container *ngTemplateOutlet="headerTemplateView"></ng-container>
  </ng-template>

  @if (visible()) {
  <ng-container *ngTemplateOutlet="conteudoTemplate"></ng-container>
  }

  <ng-template pTemplate="footer">
    <ng-container *ngTemplateOutlet="footerTemplate"></ng-container>
  </ng-template>
</p-dialog>
}

<ng-template #headerTemplateView>
  <div class="w-full">
    <div
      class="pr-1 pl-1 pb-2 pt-2 border-round-lg lg:col-12 n-header-gradient"
    >
      <div class="n-header-content">
        <div class="sm:col-12 md:col-8">
          <span class="n-header-title text-white font-bold">
            <i class="pi pi-user-edit mr-2"></i>
            Complete seus dados
          </span>
        </div>
        <div class="sm:col-12 md:col-4 flex justify-content-end gap-2">
          @if (!deviceService.$isMobile()) {
          <button
            type="button"
            class="n-close-btn"
            (click)="pular()"
            [disabled]="saving()"
            aria-label="Fechar"
          >
            <i class="pi pi-times"></i>
          </button>
          }
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div class="flex gap-2 justify-content-end w-full">
    <p-button
      label="Agora não"
      severity="secondary"
      [outlined]="true"
      (onClick)="pular()"
      [disabled]="saving()"
    />
    <p-button
      label="Salvar"
      icon="pi pi-check"
      (onClick)="salvar()"
      [loading]="saving()"
    />
  </div>
</ng-template>

<ng-template #conteudoTemplate>
  <form [formGroup]="form">
    <div class="grid p-fluid">
      <div class="col-12">
        <p-message
          severity="info"
          icon="pi pi-info-circle"
          text="Mantenha seus dados atualizados para garantir uma melhor experiência no sistema."
          styleClass="w-full n-completar-info"
        />
      </div>

      @if (erroServidor()) {
      <div class="col-12">
        <p-message
          severity="error"
          icon="pi pi-exclamation-triangle"
          [text]="erroServidor()!"
          styleClass="w-full"
        />
      </div>
      }

      <div class="col-12" formGroupName="endereco">
        <lib-n-fieldset icon="pi pi-home" title="Endereço">
          <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
            <div class="w-full">
              <lib-form-field label="País" controlName="pais" [required]="true">
                @if (deviceService.$isMobile()) {
                <lib-n-multiselect
                  [multiple]="false"
                  formControlName="pais"
                  [options]="paises"
                  optionLabel="nome"
                  optionValue="codigo"
                  placeholder="Selecione o país"
                />
                } @else {
                <p-select
                  formControlName="pais"
                  [options]="paises"
                  optionLabel="nome"
                  optionValue="codigo"
                  placeholder="Selecione o país"
                  [filter]="true"
                  filterBy="nome"
                  emptyMessage="Nenhum país encontrado"
                  emptyFilterMessage="Nenhum país encontrado"
                  [appendTo]="dropdownAppendTo"
                  styleClass="w-full"
                />
                }
              </lib-form-field>
            </div>
          </div>

          @if ($enderecoBrasil()) {
          <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
            <div class="w-full md:w-4">
              <lib-form-field
                label="CEP"
                controlName="codPostal"
                [required]="true"
                helpText="Preenchimento automático"
              >
                <p-inputMask
                  formControlName="codPostal"
                  mask="99999-999"
                  placeholder="00000-000"
                  styleClass="w-full"
                  (onBlur)="buscarCep($event)"
                  autocomplete="off"
                ></p-inputMask>
              </lib-form-field>
            </div>
            <div class="w-full md:w-8">
              <lib-form-field
                label="Logradouro"
                controlName="logradouro"
                [required]="true"
              >
                <input
                  pInputText
                  formControlName="logradouro"
                  class="w-full"
                  placeholder="Rua, Avenida, etc"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
          </div>

          <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
            <div class="w-full md:w-3">
              <lib-form-field
                label="Número"
                controlName="numero"
                [required]="true"
              >
                <input
                  pInputText
                  formControlName="numero"
                  class="w-full"
                  placeholder="123"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
            <div class="w-full md:w-9">
              <lib-form-field label="Complemento" controlName="complemento">
                <input
                  pInputText
                  formControlName="complemento"
                  class="w-full"
                  placeholder="Apto, Sala, etc"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
          </div>

          <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
            <div class="w-full md:w-6">
              <lib-form-field
                label="Bairro"
                controlName="bairro"
                [required]="true"
              >
                <input
                  pInputText
                  formControlName="bairro"
                  class="w-full"
                  placeholder="Digite o bairro"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
            <div class="w-full md:w-6">
              <lib-form-field
                label="Cidade"
                controlName="cidade"
                [required]="true"
              >
                <input
                  pInputText
                  formControlName="cidade"
                  class="w-full"
                  placeholder="Digite a cidade"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
          </div>

          <div class="flex flex-column md:flex-row w-full gap-3">
            <div class="w-full md:w-6">
              <lib-form-field
                label="Estado"
                controlName="estado"
                [required]="true"
              >
                @if (deviceService.$isMobile()) {
                <lib-n-multiselect
                  [multiple]="false"
                  formControlName="estado"
                  id="estado"
                  [options]="estados"
                  placeholder="Selecione o estado"
                />
                } @else {
                <p-select
                  [options]="estados"
                  formControlName="estado"
                  placeholder="Selecione o estado"
                  id="estado"
                  [styleClass]="'w-full'"
                  appendTo="body"
                />
                }
              </lib-form-field>
            </div>
          </div>
          } @else {
          <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
            <div class="w-full md:w-8">
              <lib-form-field
                label="AddressLine"
                controlName="logradouro"
                [required]="true"
              >
                <input
                  pInputText
                  formControlName="logradouro"
                  class="w-full"
                  placeholder="Street, avenue"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
            <div class="w-full md:w-4">
              <lib-form-field
                label="AddressNumber"
                controlName="numero"
                [required]="true"
              >
                <input
                  pInputText
                  formControlName="numero"
                  class="w-full"
                  placeholder="12"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
          </div>

          <div class="flex flex-column md:flex-row w-full gap-3 mb-3">
            <div class="w-full md:w-6">
              <lib-form-field
                label="City"
                controlName="cidade"
                [required]="true"
              >
                <input
                  pInputText
                  formControlName="cidade"
                  class="w-full"
                  placeholder="City"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
            <div class="w-full md:w-6">
              <lib-form-field
                label="Region/administrativeArea"
                controlName="estado"
                [required]="true"
              >
                <input
                  pInputText
                  formControlName="estado"
                  class="w-full"
                  placeholder="Region"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
          </div>

          <div class="flex flex-column md:flex-row w-full gap-3">
            <div class="w-full md:w-6">
              <lib-form-field
                label="PostalCode"
                controlName="codPostal"
                [required]="true"
              >
                <input
                  pInputText
                  formControlName="codPostal"
                  class="w-full"
                  placeholder="Postal code"
                  maxlength="20"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
          </div>
          }
        </lib-n-fieldset>
      </div>

      <div class="col-12">
        <lib-n-fieldset icon="pi pi-user" title="Dados pessoais">
          <div class="grid p-fluid">
            <div class="col-12 lg:col-6">
              <lib-form-field
                label="Telefone"
                controlName="telefone"
                [required]="true"
              >
                <lib-phone-input
                  [value]="form.get('telefone')?.value ?? ''"
                  (valueChange)="onTelefoneChange($event)"
                />
              </lib-form-field>
            </div>

            <div class="col-12 lg:col-6">
              <lib-form-field
                label="Data de nascimento"
                controlName="dataNascimento"
                [required]="true"
              >
                <p-datepicker
                  formControlName="dataNascimento"
                  dateFormat="dd/mm/yy"
                  [showIcon]="true"
                  [maxDate]="hoje"
                  placeholder="Selecione a data"
                  styleClass="w-full"
                  appendTo="body"
                />
              </lib-form-field>
            </div>

            @if ($exibirCpf()) {
            <div class="col-12 lg:col-6">
              <lib-form-field label="CPF/CNPJ" controlName="cpfCnpj">
                <input
                  pInputText
                  formControlName="cpfCnpj"
                  class="w-full"
                  (input)="formatarCpfCnpj($event)"
                  placeholder="000.000.000-00"
                  autocomplete="off"
                />
              </lib-form-field>
            </div>
            }

            <div class="col-12 lg:col-6">
              <lib-form-field label="Sexo" controlName="sexo">
                @if (deviceService.$isMobile()) {
                <lib-n-multiselect
                  [multiple]="false"
                  formControlName="sexo"
                  [options]="sexoOpcoes"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione o sexo"
                />
                } @else {
                <p-select
                  [options]="sexoOpcoes"
                  formControlName="sexo"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione o sexo"
                  [styleClass]="'w-full'"
                  appendTo="body"
                />
                }
              </lib-form-field>
            </div>
          </div>
        </lib-n-fieldset>
      </div>
    </div>
  </form>
</ng-template>
